import {useContext} from 'react';

import styled from '@emotion/styled';
import {useTranslation} from 'react-i18next';

import {TableCell} from '@mui/material';

import {BasicTableRow} from '../../../../../../components/BasicTable/BasicTableRow';
import {TextOverflowWithTooltip} from '../../../../../../components/TextOverflowWithTooltip/TextOverflowWithTooltip';
import {SnackBarContext} from '../../../../../../contexts/SnackBarContext/SnackBarContext';
import {CompanyAdmin} from '../../../../../../features/company/profile/types';
import {copyTextToClipBoard} from '../../../../../../utils/copyTextToClipboard/copyTextToClipBoard';

interface CompanyAdminRowProps extends CompanyAdmin {
  id: string;
}

const StyledCell = styled(TableCell)(() => ({
  paddingTop: '16px',
  paddingBottom: '16px',
  maxWidth: '80px',
}));

export const CompanyAdminRow = ({firstName, lastName, email}: CompanyAdminRowProps) => {
  const {dispatchMessage} = useContext(SnackBarContext);
  const {t} = useTranslation();

  const copyEmail = async (email: string) => {
    try {
      await copyTextToClipBoard(email);
      dispatchMessage(t('companyApplicants.snackbars.copyEmail'), 'success');
    } catch (e: unknown) {
      dispatchMessage(t('companyApplicants.snackbars.errorCopyEmail'), 'error');
    }
  };

  return (
    <BasicTableRow rowVariant='flat'>
      <StyledCell>
        <TextOverflowWithTooltip variant='body2' text={`${firstName} ${lastName}`} />
      </StyledCell>
      <StyledCell>
        <TextOverflowWithTooltip
          variant='body2'
          text={email}
          sx={{
            '&:hover': {
              cursor: 'pointer',
            },
          }}
          copyToClipboard={() => copyEmail(email)}
        />
      </StyledCell>
    </BasicTableRow>
  );
};
